<template>
  <div class="card-form">
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditDialog="openEditDialog"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @openEditDialog="openEditDialog"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <EditFormDialog
      :visible.sync="openEditDialogOptions.visible"
      :title="openEditDialogOptions.title"
      :mrpOutsourcingOrderCode="openEditDialogOptions.code"
      :disabled="openEditDialogOptions.disabled"
      @reload="reload"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import EditFormDialog from '../edit-form/dialog.vue'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, EditFormDialog },
  data() {
    return {
      usePage: true,
      openEditDialogOptions: {
        visible: false,
        code: '',
      },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .mrpOutsourcingOrderListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditDialog({ type, code }) {
      const types = {
        add: this.$l('dialog_title_outsourcing_order_add') || '新增委外订单',
        edit: this.$l('dialog_title_outsourcing_order_edit') || '编辑委外订单',
        detail: this.$l('dialog_title_outsourcing_order_detail') || '委外订单详情',
      }
      this.openEditDialogOptions = {
        visible: true,
        code,
        title: types[type],
        disabled: type === 'detail',
      }
    },
  },
}
</script>
